module.exports = __webpack_public_path__ + "assets/img/charlotte.8a75f1b2.jpg";